export const setToken = (state, payload) => state.token = payload;

export const setUser = (state, payload) => state.user = payload;

export const setIsRoleApplication = (state, payload) => state.isRoleApplication = payload;

export const setCalendar = (state, payload) => state.user.calendar = payload;

export const setLogin = (state, payload) => state.login = payload;

export const setLogged = (state, logged) => state.isLogged = logged;

export const setCompanies = (state, payload) => state.companies = payload;

export const setWorkspace = (state, payload) => state.workspace = payload;

export const setCompany = (state, payload) => state.company = payload;

export const setAlert = (state, payload) => state.login.isAlert = payload;

export const updateUserCompany = (state, payload) => {
  state.user.workspace = payload
}

export const setFirstLogin = (state, payload) => state.user.first_logged_in_at = payload;

export const updateNotification = (state, payload) => state.user.notification = payload;

export const updatePaymentStep = (state, payload) => {
  state.user.payment_step = payload
}

export const setRegisterEmail = (state, payload) => state.registerEmail = payload;